export const USER_LIST = 'USER_LIST'
export const USER_DETAIL = 'USER_DETAIL'
export const USER_ADD = 'USER_ADD'
export const USER_EDIT = 'USER_EDIT'
export const USER_DELETE = 'USER_DELETE'
export const USER_HISTORY = 'USER_HISTORY'
export const HISTORY_WRITE = 'HISTORY_WRITE'
export const PERMISSIONS = 'PERMISSIONS'
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD'
